interface BaseOption {
  id: string;
}

/**
 * Get FilterOptions, which filters by id or displayed label.
 * Note that our users like to filter for a specific `UUID`. This is because we have several options with the
 * same name, but different `UUID`s.
 */
export function getFilterOptions<T extends BaseOption>(
  options: T[],
  value: string,
  getOptionLabel: (option: T) => string
): T[] {
  const lowerCaseValue = value.toLowerCase();
  return options.filter(
    (option) => option.id === value || getOptionLabel(option).toLowerCase().includes(lowerCaseValue)
  );
}
